/**
 * Photos fields this tab has deltas in flight on. While held, incoming
 * snapshots can't overwrite the field (Issue.values merge, apollo-client.ts):
 * one read before the delta committed would undo it. The grace covers events
 * that arrive over the socket after the delta's HTTP response.
 */
export const PHOTO_FIELD_HOLD_GRACE_MS = 2000;

const holds = new Map<string, number>();

const keyOf = (issueId: string, fieldId: string) => `${issueId}:${fieldId}`;

/** Returns an idempotent release. */
export function holdPhotoField(issueId: string, fieldId: string): () => void {
  const key = keyOf(issueId, fieldId);
  holds.set(key, (holds.get(key) ?? 0) + 1);
  let released = false;
  return () => {
    if (released) return;
    released = true;
    setTimeout(() => {
      const next = (holds.get(key) ?? 1) - 1;
      if (next <= 0) holds.delete(key);
      else holds.set(key, next);
    }, PHOTO_FIELD_HOLD_GRACE_MS);
  };
}

export function heldPhotoFieldIds(issueId: string): string[] {
  const prefix = `${issueId}:`;
  const out: string[] = [];
  for (const key of holds.keys()) {
    if (key.startsWith(prefix)) out.push(key.slice(prefix.length));
  }
  return out;
}
